import { Input } from '@/components/ui/input'

const DateField = ({ field, id = field.id, value, onChange, disabled }) => (
  <Input
    type="date"
    id={id}
    value={value || ''}
    onChange={(e) => onChange(e.target.value)}
    disabled={disabled}
  />
)

export default DateField
